import { useEffect } from "react";

import { useQueryState } from "nuqs";
import { WIDGETS } from "@/constants/widgets";
import { WIDGETS_SEARCH_QUERY_PARAM_NAMES } from "@/components/shared/widgets/constants";

export const useMaxedDialerSearchQueryParams = ({
  campaignId,
  accountId,
  contactId,
  phone,
  email,
}: {
  campaignId?: string;
  accountId?: string;
  contactId?: string;
  phone?: string;
  email?: string;
}) => {
  const [, setWidgetType] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.WIDGET_TYPE
  );
  const [, setCampaignId] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.CAMPAIGN_ID
  );
  const [, setAccountId] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.ACCOUNT_ID
  );
  const [, setContactId] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.CONTACT_ID
  );
  const [, setPhone] = useQueryState(WIDGETS_SEARCH_QUERY_PARAM_NAMES.PHONE);
  const [, setEmail] = useQueryState(WIDGETS_SEARCH_QUERY_PARAM_NAMES.EMAIL);

  useEffect(() => {
    setWidgetType(WIDGETS.MAXED_DIALER);

    return () => {
      setWidgetType(null);
      setCampaignId(null);
      setAccountId(null);
      setContactId(null);
      setPhone(null);
      setEmail(null);
    };
  }, []);

  useEffect(() => {
    setCampaignId(campaignId || null);
    setAccountId(accountId || null);
  }, [campaignId, accountId]);

  useEffect(() => {
    setContactId(contactId || null);
  }, [contactId]);

  useEffect(() => {
    setPhone(phone || null);
  }, [phone]);

  useEffect(() => {
    setEmail(email || null);
  }, [email]);
};
